import React, { useState } from "react";
import { Stack, Typography, styled, Avatar } from "@mui/material";
import BadgeVisual from "../visuals/BadgeVisual";

const Card = styled(Stack)(({ theme }: any) => ({
  width: "200px",
  height: "256px",
  border: `1px solid ${theme.palette.common.borderGrey}`,
  "& .p-2": {
    padding: theme.spacing(2),
  },
}));

interface SponserCardInterface {
  image: string;
  company: string;
  city: string;
  sponsership?: "silver" | "golden" | "platinum";
}
const sponsershipList: any = {
  golden: { label: "Golden Sponser", color: "golden" },
  platinum: { label: "Platinum Sponser", color: "platinum" },
  silver: { label: "Silver Sponser", color: "silver" },
};
const SponserCard = ({
  image,
  company,
  city,
  sponsership,
}: SponserCardInterface) => {
  const [bookmarked, setBookmarked] = useState(false);
  return (
    <Card spacing={1} alignItems="center">
      <Stack
        width="100%"
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        {bookmarked ? (
          <i
            className="fas fa-bookmark fa-lg p-2"
            onClick={() => setBookmarked(!bookmarked)}
          />
        ) : (
          <i
            className="far fa-bookmark fa-lg p-2"
            onClick={() => setBookmarked(!bookmarked)}
          />
        )}
        {sponsership && sponsershipList[sponsership] ? (
          <BadgeVisual
            label={sponsershipList[sponsership].label}
            color={sponsershipList[sponsership].color}
            borderPlacement="bottom-left"
          />
        ) : null}
      </Stack>
      <Stack spacing={1} textAlign="center">
        <Avatar
          alt="Remy Sharp"
          src={image}
          sx={{ width: "128px", height: "128px" }}
        />

        <Typography color="primary" variant="h3" fontWeight={700}>
          {company}
        </Typography>
        <Typography color={(theme: any) => theme.palette.common.grey}>
          {city}
        </Typography>
      </Stack>
    </Card>
  );
};
export default SponserCard;
